import React from "react";
import clsx from "clsx";

import Dialog, { DialogProps } from "@material-ui/core/Dialog";

import useStyles from "./styles";

interface IProps extends Omit<DialogProps, "open"> {
  children: React.ReactNode;
  open?: boolean;
  className?: string;
}

const OverlayPage = (props: IProps) => {
  const { children, open = true, className, ...restProps } = props;
  const classes = useStyles();

  return (
    <Dialog
      {...restProps}
      className={clsx(className, classes.root)}
      open={open}
      fullScreen
    >
      {children}
    </Dialog>
  );
};

export default OverlayPage;
